
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/goat-clean",
      function () {
        return require("private-next-pages/goat-clean/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/goat-clean"])
      });
    }
  